import {
  computed,
  ref
} from "vue";
import {
  defineStore
} from "pinia";

import {
  CONFIG
} from "@/game/runtime/core/config.js";

import {
  isLevelCompleted,
  isLevelUnlocked,
  loadProgress,
  projectHomeProgress
} from "@/game/runtime/systems/progressStore.js";

import {
  gameRuntimeBridge
} from "@/game/bridge/runtimeBridge.js";


export const PLAYABLE_LEVEL_COUNT =
  Array.isArray(
    CONFIG.levelOrder
  )
    ? CONFIG.levelOrder.length
    : CONFIG.levelCount;


export const useProgressStore =
  defineStore(
    "progress",
    () => {
      const progress =
        ref(
          loadProgress(
            PLAYABLE_LEVEL_COUNT
          )
        );

      const highestUnlocked =
        computed(
          () =>
            Math.max(
              1,
              Math.min(
                PLAYABLE_LEVEL_COUNT,
                Number(
                  progress.value
                    .highestUnlocked
                ) || 1
              )
            )
        );

      const clearedCount =
        computed(
          () => {
            let count = 0;

            for (
              let level = 1;
              level
                <= PLAYABLE_LEVEL_COUNT;
              level += 1
            ) {
              if (
                isLevelCompleted(
                  progress.value,
                  level
                )
              ) {
                count += 1;
              }
            }

            return count;
          }
        );

      function applyHome(
        home
      ) {
        progress.value =
          projectHomeProgress(
            home,
            PLAYABLE_LEVEL_COUNT
          );

        gameRuntimeBridge
          .setProgressFromHome(
            home
          );

        return progress.value;
      }

      /*
       * Compatibility method for existing
       * view calls.
       *
       * It no longer reloads browser data.
       */
      function refresh() {
        return progress.value;
      }

      function isUnlocked(
        level
      ) {
        return (
          level
            <= PLAYABLE_LEVEL_COUNT
          && isLevelUnlocked(
            progress.value,
            level
          )
        );
      }

      function isCompleted(
        level
      ) {
        return isLevelCompleted(
          progress.value,
          level
        );
      }

      return {
        progress,
        highestUnlocked,
        clearedCount,
        applyHome,
        refresh,
        isUnlocked,
        isCompleted
      };
    }
  );
